module.exports = __webpack_public_path__ + "6da1e51f3cb6eb5530296f4fc5f70be5.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/Foto_Manja_Herrmann-0152_klein.jpg
// module id = 598
// module chunks = 0